var _style, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage06Layer1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 750 573",
    style: {
      enableBackground: "new 0 0 750 573"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{opacity:.5;fill:#02cbd8;enable-background:new}.st1{fill:none}.st2{opacity:.6;fill:url(#SVGID_1_);enable-background:new}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M654.5 504.8l-33-9.2 42.2-23.7L654.5 504.8zM535.4 342.5l42.2-23.7-33-9.2L535.4 342.5zM515.7 412.9l132.2-74.4-42.2-11.8-78.2 44L515.7 412.9zM683.4 401.5l-132.2 74.4 42.2 11.8 78.2-44L683.4 401.5zM697.2 352.2l-21.1-5.9L507.8 441l-5.9 21.1L523 468l168.2-94.7L697.2 352.2z"
  })), /*#__PURE__*/React.createElement("g", null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M317.9 355.4c-113.9.0-206.5 92.6-206.5 206.5.0 3.7.1 7.4.3 11.1h412.4c.2-3.7.3-7.4.3-11.1C524.4 448 431.8 355.4 317.9 355.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 317.89,
    y1: -269.0002,
    x2: 317.89,
    y2: 292.9598,
    gradientTransform: "matrix(1 0 0 -1 0 573.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6784,
    style: {
      stopColor: "#00cbd8",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00cbd8"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M576.8 452.5c-14.2-33.5-34.4-63.5-60.2-89.3-25.8-25.8-55.8-46-89.3-60.2-34.7-14.7-71.5-22.1-109.4-22.1-37.9.0-74.7 7.4-109.4 22.1-33.5 14.2-63.5 34.4-89.3 60.2-25.8 25.8-46 55.8-60.2 89.3C44.3 487.2 36.9 524 36.9 561.9c0 3.7.1 7.4.2 11.1h74.5c-.2-3.7-.3-7.4-.3-11.1.0-113.9 92.7-206.5 206.5-206.5 113.9.0 206.5 92.6 206.5 206.5.0 3.7-.1 7.4-.3 11.1h74.5c.1-3.7.2-7.4.2-11.1C598.9 524 591.4 487.2 576.8 452.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage06Layer1);
export default __webpack_public_path__ + "static/media/image-06-layer-1.37888e3d311e821904d88fd9908096be.svg";
export { ForwardRef as ReactComponent };